/* Raghu  27/10/2022 3075154998 Card Styling Changes */
import React from 'react';
import SearchEnableFormatContainer from './SearchEnableFormatContainer';

function SearchEnableFileFormat({setTabValue, setEnableCode, setResetData}) {
  return (
    <div>
      <div className={`mb-0`}>
        <SearchEnableFormatContainer setTabValue={setTabValue} setEnableCode={setEnableCode} setResetData={setResetData} />
      </div>
    </div>
  );
}

export default SearchEnableFileFormat;
